import Store from '../configureStore';
import { FeedbackState } from '../reducers/feedback.reducer';

export const setFeedback = (payload: FeedbackState) => ({
  type: 'SET_FEEDBACK',
  payload
});
export const clearFeedback = () => ({
  type: 'CLEAR_FEEDBACK'
});

export const boundClearFeedback = () => Store.dispatch(clearFeedback());

export const boundSetFeedback = (state: FeedbackState) =>
  Store.dispatch(setFeedback(state));
